/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/21/20
 * Time: 1:54 PM
 */
import React, {Component} from 'react';
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import floor_icon from "../../../assets/img/recept_checkin/floor.svg";
import * as common from "../../../const/Common/CommonFunc";
import {Col, Row} from "reactstrap";
import building_icon from "../../../assets/img/recept_checkin/building.svg";
import './Dashboard.scss';
import Cookies from "js-cookie";
import * as keys from "../../../const/key/Key";
import HealthDeclaration from "../HealthDeclaration/HealthDeclaration";
import {Button, Checkbox, Form} from "semantic-ui-react";
import DrpDwn from "../../../components/Dropdown/Dropdown/DrpDwn";
import TxtLbl from "../../../components/Input/Input/TxtLbl";
import * as healthConstants from "../../../const/health/Health";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
// import axios from "../../../axios/axios_tag";
import axiosVisitor from "../../../axios/axios_visitortag";
import apiConfig from "../../../axios/axios_api_services";
import cloneDeep from 'lodash/cloneDeep';
import ResultModal from "./ResultModal/ResultModal";
import * as routeConstants from "../../../const/route/Route";
import axiosTags from "../../../axios/axios_tag";

const initialState = {
  meeting_building: '',
  meeting_building_id: '',
  meeting_floor: '',
  visitor_purpose: '',

  healthObj: {
    active: 1, max: 8, health: [], success: 1, curIndex: 1,
  },

  isAgree: false,
  brachId: '',
  location: 2,

  openModal: false, responseResult: false, responseMessage: "",
  responseClassName: "success-modal-alert", corporateName: '', corporatePhotoPath: ''
};

class App extends Component {

  state = Object.assign({}, initialState);

  changeHealthState = (name, value) => {
    let {healthObj} = this.state;
    healthObj[name] = value;
    this.setState({healthObj})
  };

  changeLocation = (index) => {
    this.setState({location: index})
  };

  buildingOnChange = (e, {value}) => {
    this.autoSettleBuidling(null, value)
  };

  autoSettleBuidling = (buildingList, value) => {

    if (buildingList === null) {
      buildingList = this.props.all_building_list;
    }
    let selectedBuilding = buildingList[value];

    const floor_options = [];
    if (selectedBuilding.floors.length !== 0) {
      selectedBuilding.floors.map((element, index) => {
        floor_options.push({
          key: element.floor_id,
          text: element.description,
          value: element.floor_id,
          image: {avatar: true, src: floor_icon},
        })
      })
    }

    this.setState({
      meeting_floor: selectedBuilding.floors.length !== 0 ? selectedBuilding.floors[0].floor_id : "",
      meeting_building: value,
      meeting_building_id: selectedBuilding.buildingId
    });
    this.props.receptionAllFloorHandler(floor_options);
  };

  floorOnChange = (e, {value}) => {
    this.setState({meeting_floor: value});
  };
  handleChange = name => event => {
    let value = event.target.value;
    this.setState({
      [name]: value
    });
  };
  covidDetails = (obj) => {
    this.setState({healthObj: obj})
  };
  meetingSheduleHandler = () => {
    let {meeting_building_id, meeting_floor, healthObj, isAgree} = this.state;
    let healthList = cloneDeep(healthObj.health);

    // let emptyHealth = healthList.find(obj => obj.result === "");
    // if (emptyHealth !== undefined) {
    //   condition = emptyHealth.covid_question_id === 8 && healthList[6].result === healthConstants.NO_RESULT;
    // }

    let covidAnswers = [];
    healthList.map(obj => {
      covidAnswers.push({covid_question_id: obj.covid_question_id, response: obj.result === healthConstants.YES_RESULT})
    });
    healthConstants.healthConstants.map((healthObj,index)=>{
      let condition = false;
      if(healthList.length !== 0){
        healthList.map((hlthObj,i)=>{
          if(healthObj.covid_question_id === hlthObj.covid_question_id) condition = true;
        })
      }
      if(!condition){
        covidAnswers.push({covid_question_id: healthObj.covid_question_id, response: false})
      }
    });

      !isAgree ? common.notifyMessage("Please accept the answers") :
        meeting_building_id === "" ? common.notifyMessage("Please select building") :
          meeting_floor === "" ? common.notifyMessage("Please select floor") :
            swal({
              title: "Do you want to proceed", icon: are_you_sure_icon, closeOnClickOutside: false,
              buttons: {cancel: 'Cancel', dangerMode: {text: "Yes", value: "action", className: "okay-btn"}},
            })
              .then((value) => {
                switch (value) {
                  case "action":
                    this.submitHandler(covidAnswers);
                    break;
                  default:
                }
              });
  };

  submitHandler = (health) => {
    let {brachId, meeting_floor, visitor_purpose} = this.state;
    const obj = {branchId: brachId, floorId: meeting_floor, purpose: visitor_purpose, covidAnswers: health};

    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer" + Cookies.get(keys.ACCESS_TOKEN)
    };
    axiosVisitor.post(apiConfig.GUEST_USER_CHECK_IN, obj, {headers: headers})
      .then(response => {

        if (response.data.success) {
          this.setState({
            openModal: true,
            responseClassName: "success-modal-alert",
            responseResult: true,
            responseMessage: response.data.message,
            corporateName: response.data.corporateName,
            corporatePhotoPath: response.data.corporatePhotoPath
          })

        } else {
          if (response.data.visitorGranted === false) {
            this.setState({
              openModal: true,
              responseClassName: "err-modal-alert",
              responseResult: false,
              responseMessage: response.data.message,
              corporateName: response.data.corporateName,
              corporatePhotoPath: response.data.corporatePhotoPath
            });
            return;
          }
          common.warningAlert(response.data.message, 1, 'err-modal-alert')
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error, keys.GUEST_USER_USER_ROLE);
        if (result === 1) {
          this.submitHandler(health);
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };

  buildingHandler = (index) => {
    let {meeting_building_id, meeting_floor} = this.state;
    meeting_building_id === "" ? common.notifyMessage("Please select building") :
      meeting_floor === "" ? common.notifyMessage("Please select floor") :
        this.changeLocation(index)
  };
  closeModalHandler = () => {
    Cookies.remove(keys.ACCESS_TOKEN);
    Cookies.remove(keys.REFRESH_TOKEN);
    localStorage.removeItem(keys.GUEST_CACHE);

    let {corporateName, corporatePhotoPath} = this.state;
    this.props.history.push({
      pathname: routeConstants.PUBLIC_THANK_YOU_PAGE,
      state: {corporateName: corporateName, corporatePhotoPath: corporatePhotoPath}
    });
  };

  callAllBuildings = (id, userRole) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get(keys.ACCESS_TOKEN)
    };

    axiosTags.get(apiConfig.GUEST_GET_ALL_BUILDING_BY_BRANCH(id), {headers: headers})
      .then(response => {
        if (response.data.success) {
          let buildingList = response.data.buildingList;
          this.props.receptionAllBuildingHandler(buildingList);
          if (buildingList.length !== 0) {
            this.autoSettleBuidling(buildingList, 0);
          }
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error, userRole);
        if (result === 1) {
          this.callAllBuildings(id, userRole);
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };

  componentWillMount() {
    let {guestIsLogin, branchId} = this.props.guest_data;

    if (branchId && guestIsLogin) {
      let data = cloneDeep(healthConstants.healthConstants);
      this.callAllBuildings(branchId, keys.GUEST_USER_USER_ROLE);

      let selectedDynamicList = healthConstants.GUEST_FILTER_CORPORATE_COVID.find(obj => obj.corporateId === this.props.guest_corporate_id);
      let customizeList = [];
      let max = 1;
      if (selectedDynamicList) {
        data.map((objCovid, index) => {
          if (selectedDynamicList.selectedQuestions.length !== 0) {
            selectedDynamicList.selectedQuestions.map((objSelectedCovid,i)=>{
              if(objSelectedCovid === objCovid.covid_question_id){
                max = i+1;
                customizeList.push({
                  index: i,
                  covid_question_id: objCovid.covid_question_id,
                  english: objCovid.english,
                  sinhala: objCovid.sinhala,
                  tamil: objCovid.tamil,
                  chinese: objCovid.chinese,
                  response: objCovid.response,
                  result: objCovid.result,
                })
              }
            })
          }
        });
      }

      this.setState({brachId: branchId, healthObj: {...this.state.healthObj,max:max, health: customizeList}});
    }
  }

  render() {
    let {meeting_floor, visitor_purpose, meeting_building, location, isAgree, openModal, responseResult, responseMessage, responseClassName} = this.state;
    let all_building_list = this.props.all_building_list;
    let floor_options = this.props.all_floor_list;

    const building_options = [];
    if (all_building_list.length !== 0) {
      all_building_list.map((element, index) => {
        building_options.push({
          key: index, text: element.name, value: index,
          image: {avatar: true, src: building_icon},
        })
      })
    }
    return (
      <div className={"guest-dashboard"}>
        {
          openModal ? <ResultModal closeModalHandler={this.closeModalHandler} responseClassName={responseClassName}
                                   responseResult={responseResult} responseMessage={responseMessage}/> : null
        }
        {
          location === 1 ?
            <Row className={"bottom-div"}>
              <Col lg={12}>
                <Form>
                  <Form.Group widths='equal' className={"guest-dash-group"}>
                    <DrpDwn
                      // required
                      value={meeting_building}
                      // tagText={"Building | ගොඩනැගිල්ල | கட்டிடம் "}
                      tagText={<span><span className={"lng-eng"}>Building</span> / <span
                        className={"lng-sin"}>ගොඩනැගිල්ල</span> / <span className={"lng-tml"}>கட்டிடம்</span></span>}
                      placeholder={"Select building"}
                      options={building_options}
                      onChange={this.buildingOnChange}
                    />
                  </Form.Group>
                </Form>
              </Col>
              <Col lg={12}>
                <Form>
                  <Form.Group widths='equal' className={"guest-dash-group"}>
                    <DrpDwn
                      // required
                      // tagText={"Floor | මහල | தரை "}
                      tagText={<span><span className={"lng-eng"}>Floor</span> / <span
                        className={"lng-sin"}>මහල</span> / <span className={"lng-tml"}>தரை</span></span>}
                      placeholder={"Select floor"}
                      options={floor_options}
                      value={meeting_floor}
                      onChange={this.floorOnChange}
                    />
                  </Form.Group>
                </Form>
              </Col>
              <Col lg={12}>
                <Form>
                  <Form.Group widths='equal' className={"guest-dash-group"}>
                    <TxtLbl
                      // required
                      // tagText={"Purpose | අරමුණ | நோக்கம்"}
                      tagText={<span><span className={"lng-eng"}>Purpose</span> / <span
                        className={"lng-sin"}>අරමුණ</span> / <span className={"lng-tml"}>நோக்கம்</span></span>}
                      placeholder={"Visiting Purpose"}
                      value={visitor_purpose}
                      onChange={this.handleChange('visitor_purpose')}
                    />

                  </Form.Group>
                </Form>
              </Col>

              <Col lg={12} className={"align-right_ text-align-path"}>

                <Button className="submit-btn ui button "
                        onClick={() => this.changeLocation(2)}>Not sure? Skip</Button>
                <Button className="px-5 mt-5"
                        onClick={() => this.buildingHandler(2)}>Next</Button>

              </Col>
            </Row> :
            location === 2 ?
              <Row>
                <Col xs={12}>
                  <HealthDeclaration covidDetails={this.covidDetails} healthLength={this.state.health}
                                     changeState={this.changeHealthState}
                                     healthObj={this.state.healthObj} changeLocation={this.changeLocation}/>
                </Col>
              </Row> :
              location === 3 ?
                <Row className={"bottom-div"}>
                  <Col xs={12}>
                    <div className={"check-box-wrapper"}>
                      <Checkbox style={{cursor: 'pointer'}}
                                label={
                                  <label>
                                    <span className={"lng-eng"}>I declare all the information given by me is true and correct?</span>
                                    <br/>
                                    මා ලබා දුන් සියලු තොරතුරු සත්‍ය සහ නිවැරදි බව මම සනාත කරමි.<br/>
                                    நான் கொடுத்த அனைத்து தகவல்களும் உண்மை மற்றும் சரியானவை என்று நான்
                                    அறிவிக்கிறேன்.
                                    {/*<br/>*/}
                                    {/*我声明我提供的所有信息都是正确的吗？*/}
                                  </label>
                                }
                                onChange={() => this.setState({isAgree: !isAgree})}
                                checked={isAgree}
                      />
                    </div>
                  </Col>
                  <Col xs={"12"} className={"agree-btn-wrapper"}>
                    <div>
                      <Button className="back-btn ui button"
                              onClick={() => this.changeLocation(2)}>Back</Button>

                      <Button className="submit-btn ui button"
                              onClick={this.meetingSheduleHandler}>Submit</Button>
                    </div>
                  </Col>
                </Row> : null
        }
        <br/>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({

  all_building_list: state.reception_SheduleMeetingReducer.all_building_list,
  all_floor_list: state.reception_SheduleMeetingReducer.all_floor_list,

  usr_obj: state.userReducer.user,
  visitors_purpose_options_list: state.reception_SheduleMeetingReducer.visitors_purpose_options_list,
  guest_data: state.guestUserReducer.guestUser,
  guest_corporate_id: state.guestUserReducer.guestCurrentCorporateId,
});

const mapDispatchToProps = (dispatch) => {
  return {
    callAllBuildings: (data, userRole) => dispatch(actionCreator.callAllBuildingsByBranchId(data, userRole)), // Get All Buildings Of Corporate
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // all floors
    receptionAllFloorHandler: (data) => dispatch(actionCreator.receptionAllFloorHandler(data)),
    // building handler
    receptionAllBuildingHandler: (data) => dispatch(actionCreator.receptionAllBuildingHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
